@let dialog = service.currentDialog$ | async;
@if (dialog) {
  @switch (dialog.kind) {
    @case ('alert') {
      <app-alert-dialog
        [visible]="true"
        [dialogTitle]="dialog.title"
        [dialogSubtitle]="dialog.subtitle"
        [isError]="dialog.isError"
        (onClose)="service.dequeueDialog($event)"
        >
      </app-alert-dialog>
    }
    @case ('confirm') {
      <app-confirm-dialog
        [visible]="true"
        [dialogTitle]="dialog.title"
        [dialogSubtitle]="dialog.subtitle"
        (answered)="service.dequeueConfirmDialog($event)"
        >
      </app-confirm-dialog>
    }
    @case ('location') {
      <app-select-event-location-dialog
        [locations]="dialog.locations"
        (answered)="service.dequeueSelectLocationDialog($event)"
        >
      </app-select-event-location-dialog>
    }
    @case ('selectOneRadio') {
      <app-select-one-radio
        [visible]="true"
        [dialogTitle]="dialog.title"
        [dialogSubtitle]="dialog.subtitle"
        [cancelBehavior]="dialog.cancelFunction"
        [possibilities]="dialog.possibilities"
        (answered)="service.dequeueConfirmDialog($event)"
        >
      </app-select-one-radio>
    }
  }
}
